<template>
    <section class="bg-[#ccccc] py-12 px-4">
      <div class="max-w-6xl mx-auto bg-white  -mt-28  rounded-2xl shadow p-24">
        <h2 class="text-center text-2xl sm:text-3xl font-bold text-gray-800 mb-10">
          ESPECIFICAÇÕES DO DATA CENTER
        </h2>
  
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 text-sm text-gray-800">
        <div
            v-for="(item, index) in especificacoes"
            :key="index"
            class="flex items-center gap-4"
        >
            <component :is="item.icone" class="w-10 h-10 text-gray-700 shrink-0" />
            <p class="text-base leading-tight ">{{ item.texto }}</p>
        </div>
        </div>


      </div>
    </section>
  </template>
  
  <script setup>
  import {
    ShieldCheck,
    Server,
    BadgeCheck,
    Globe,
    Landmark,
    CheckCircle,
    Router,
    Network,
    Layers
  } from 'lucide-vue-next'
  
  const especificacoes = [
    { icone: ShieldCheck, texto: 'Provedor de Serviços PCI Nível 1' },
    { icone: Router, texto: 'Roteadores Juniper Core' },
    { icone: BadgeCheck, texto: 'Linux Certified Partner' },
    { icone: Landmark, texto: 'SSAE16 Type II e SAS70 Type II' },
    { icone: CheckCircle, texto: 'Safe Harbor Certificado' },
    { icone: Network, texto: '50Gbps link dedicado' },
    { icone: Globe, texto: 'Link totalmente redundante' },
    { icone: Layers, texto: 'CDSA Certificado' },
    { icone: Server, texto: 'Rede 600 Gbps link' }
  ]
  </script>
  